<template>
  <div>
    <SettingsPageLayout>
      <DetailForm
        title="PandaDoc"
        description="As part of the onboarding process, Humaniz.io requires some specific information to be able to implement the onboarding process. The PandaDoc Broker Template Id is necessary for automatically creating the ICA Agreement for a new agent."
        action="Save"
        @handleAction="updateTeam"
        hidecancel="true"
        v-if="loaded"
      >
        <TextInput
          label="PandaDoc ICA Template Id"
          placeholder="2pj8vF2sxmUrUBv8oTtaz4"
          :modelValue="team.icaTemplateId"
          @update:modelValue="value => (team.icaTemplateId = value)"
        />
      </DetailForm>
    </SettingsPageLayout>
  </div>
</template>

<script>
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  data() {
    return {
      team: {
        id: '',
        icaTemplateId: '',
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/teams/1`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.team.id = data.record.id;
          self.team.icaTemplateId = data.record.ica_template_id;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/teams/${self.team.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          ica_template_id: self.team.icaTemplateId,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Onboarding settings updated',
              alertDescription:
                'Your Onboarding settings were successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Onboarding settings update error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
